import axios from "axios";

let config = {
	headers: {
		"Content-Type": "application/json;charset=UTF-8",
	},
	crossDomain: true,
};

const multipartConfig = {
	headers: {
		"Content-Type": "multipart/form-data",
	},
	crossDomain: true,
};

export const getRequest = async (url) => {
	let response;

	try {
		response = await axios.get(url, config);
	} catch (err) {
		throw err;
	}

	return response.data;
};

export const postRequest = async (url, body) => {
	let response;

	try {
		response = await axios.post(url, body, config);
	} catch (err) {
		throw err;
	}

	return response.data;
};

export const postFormRequest = async (url, formData) => {
	let response;

	try {
		response = await axios.post(url, formData, multipartConfig);
	} catch (err) {
		throw err;
	}

	return response.data;
};

export const putRequest = async (url, body) => {
	let response;

	try {
		response = await axios.put(url, body, config);
	} catch (err) {
		throw err;
	}

	return response.data;
};

export const downloadFileRequest = async (url) => {
	let response;

	try {
		response = await axios.get(url, { ...config, responseType: "arraybuffer" });
	} catch (err) {
		throw err;
	}

	return response.data;
};

export const deleteRequest = async (url, body) => {
	let response;
	try {
		response = await axios.delete(url, { ...config, data: body });
	} catch (err) {
		throw err;
	}

	return response.data;
};
